import React from "react";
import Skeleton from "../../skeleton";

const Dekstop = () => (

	<>
		<div className="card-skeleton-tab-user">
			<div className="card-skeleton-tab-user__section-user">
				<Skeleton
					width="200px"
					height="20px"
				/>
				<div className="card-skeleton-tab-user__user">
					{Array.from({ length: 24 }, (value, id) => (
						<div key={id} className="card-skeleton-tab-user__user-data">
							<Skeleton
								width="60px"
								height="60px"
								borderRadius="50%"
							/>
							<Skeleton
								width="80px"
								height="16px"
							/>

						</div>
					))}
				</div>
				<div className="card-skeleton-tab-user__user-button">
					<Skeleton
						width="240px"
						height="40px"
						margin="auto"
					/>
				</div>
			</div>

		</div>
		<style jsx>
			{`
				.card-skeleton-tab-user{
					max-width: 1280px;
					margin-top: 38px;
				}
				.card-skeleton-tab-user__user-data {
					display: flex;
					align-items: center;
					column-gap: 12px;
				}
				.card-skeleton-tab-user__user {
					display: grid;
					grid-template-columns: repeat(4, 1fr);
					row-gap: 30px;
					margin-top: 18px;
				}
				.card-skeleton-tab-user__section-user {
					margin-top: 38px;
				}
				.card-skeleton-tab-user__user-button{
					margin-top: 41px;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			`}
		</style>
	</>

);

export default Dekstop;
